import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintManager_allocation_configurations_grid___ds_allocation_configurations_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { applicable_config_ids?: number[] }): 
  Promise<{ result: { Id?: number, Content?: string, Context?: string, CreatedSysDateTime?: string, CreatedSysUser?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Priority?: number, Filters?: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Name?: string, Value?: string }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/FootprintManager/datasources/allocation_configurations_grid___ds_allocation_configurations_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { applicable_config_ids?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Content?: string, Context?: string, CreatedSysDateTime?: string, CreatedSysUser?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Priority?: number, Filters?: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Name?: string, Value?: string }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/FootprintManager/datasources/allocation_configurations_grid___ds_allocation_configurations_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { applicable_config_ids?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, Content?: string, Context?: string, CreatedSysDateTime?: string, CreatedSysUser?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Priority?: number, Filters?: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, ModifiedSysDateTime?: string, ModifiedSysUser?: string, Name?: string, Value?: string }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootprintManager/datasources/allocation_configurations_grid___ds_allocation_configurations_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      applicable_config_ids?: number[]    }) {
      return false;
    }
}
